module.exports = __webpack_public_path__ + "static/media/pagging-ft.83a94120.svg";